<template>
  <ChatWrapper :items="chatItems" />
</template>

<script setup lang="ts">
import ChatWrapper from '@/components/elements/ChatWrapper.vue';
import { ChatItem } from '@/types/chat';
import { computed, toRef } from 'vue';
import useAudioTranscription from '@/utilities/composables/useAudioTranscription';
import { NoteTranscriptSource } from '@superthread-com/api';

const props = defineProps({
  noteId: {
    type: String,
    required: true,
  },
});

const { transcripts } = useAudioTranscription(toRef(props, 'noteId'));

const chatItems = computed((): ChatItem[] => {
  return transcripts.value.map((t: any) => ({
    id: t.id,
    content: !t.ongoing ? t.content : `${t.content || ''} ${t.interim_content}`,
    alignment: t.source === NoteTranscriptSource.Author ? 'right' : 'left',
    processing: t.ongoing,
  }));
});
</script>
